import clickOutside from "@/directives/click-outside";

const GlobalDirectives = {
	install(Vue: any) {
		Vue.directive("click-outside", clickOutside);
	}
};

export default GlobalDirectives;
